var map = {
	"./admin/patterns/header-profile": 6508,
	"./admin/patterns/header-profile-skin-1": 9438,
	"./admin/patterns/header-profile-skin-1.png": 9438,
	"./admin/patterns/header-profile-skin-2": 6165,
	"./admin/patterns/header-profile-skin-2.png": 6165,
	"./admin/patterns/header-profile-skin-3": 4540,
	"./admin/patterns/header-profile-skin-3.png": 4540,
	"./admin/patterns/header-profile.png": 6508,
	"./admin/patterns/otis_redding": 5934,
	"./admin/patterns/otis_redding.png": 5934,
	"./admin/patterns/shattered": 795,
	"./admin/patterns/shattered.png": 795,
	"./admin/profile_small": 7364,
	"./admin/profile_small.jpg": 7364,
	"./admin/subscriptions/arrow-down": 7457,
	"./admin/subscriptions/arrow-down.svg": 7457,
	"./admin/subscriptions/arrow-up": 2510,
	"./admin/subscriptions/arrow-up.svg": 2510,
	"./alert-ic": 2163,
	"./alert-ic.svg": 2163,
	"./avatar": 2724,
	"./avatar-alliance": 7415,
	"./avatar-alliance.svg": 7415,
	"./avatar-bio": 9134,
	"./avatar-bio.svg": 9134,
	"./avatar-smart": 4607,
	"./avatar-smart.svg": 4607,
	"./avatar-white": 7940,
	"./avatar-white.png": 7940,
	"./avatar.png": 2724,
	"./bio-ritmo": 2804,
	"./bio-ritmo.svg": 2804,
	"./booking_provider/angulare": 4506,
	"./booking_provider/angulare.png": 4506,
	"./booking_provider/black_sheep": 7752,
	"./booking_provider/black_sheep.png": 7752,
	"./booking_provider/byteway": 2906,
	"./booking_provider/byteway.png": 2906,
	"./booking_provider/check_in_sports": 6725,
	"./booking_provider/check_in_sports.png": 6725,
	"./booking_provider/cloud_gym": 6470,
	"./booking_provider/cloud_gym.png": 6470,
	"./booking_provider/data_fitness": 4464,
	"./booking_provider/data_fitness.png": 4464,
	"./booking_provider/erp2go": 3592,
	"./booking_provider/erp2go.png": 3592,
	"./booking_provider/evo": 9433,
	"./booking_provider/evo.png": 9433,
	"./booking_provider/hubfit": 6023,
	"./booking_provider/hubfit.png": 6023,
	"./booking_provider/mels_fitness": 3753,
	"./booking_provider/mels_fitness.png": 3753,
	"./booking_provider/mu_fitness": 5690,
	"./booking_provider/mu_fitness.png": 5690,
	"./booking_provider/nelson_vargas_family_fitness": 3199,
	"./booking_provider/nelson_vargas_family_fitness.png": 3199,
	"./booking_provider/new_sport": 2564,
	"./booking_provider/new_sport.png": 2564,
	"./booking_provider/next_fit": 482,
	"./booking_provider/next_fit.png": 482,
	"./booking_provider/pacto": 3754,
	"./booking_provider/pacto.png": 3754,
	"./booking_provider/playformance": 5080,
	"./booking_provider/playformance.png": 5080,
	"./booking_provider/polisystem": 4360,
	"./booking_provider/polisystem.png": 4360,
	"./booking_provider/seufisio": 5896,
	"./booking_provider/seufisio.png": 5896,
	"./booking_provider/software_pilates": 3415,
	"./booking_provider/software_pilates.png": 3415,
	"./booking_provider/studio_pilates": 8866,
	"./booking_provider/studio_pilates.png": 8866,
	"./booking_provider/tecnofit": 3215,
	"./booking_provider/tecnofit.png": 3215,
	"./booking_provider/ultra_gym": 5555,
	"./booking_provider/ultra_gym.png": 5555,
	"./button-android-app-br": 3241,
	"./button-android-app-br.svg": 3241,
	"./button-android-app-mx": 6346,
	"./button-android-app-mx.svg": 6346,
	"./button-ios-app-br": 1135,
	"./button-ios-app-br.svg": 1135,
	"./button-ios-app-mx": 1936,
	"./button-ios-app-mx.svg": 1936,
	"./check": 6983,
	"./check.png": 6983,
	"./check.svg": 6872,
	"./checked": 1924,
	"./checked.png": 1924,
	"./close": 5011,
	"./close.png": 5011,
	"./day": 4289,
	"./day.png": 4289,
	"./easy-fit": 6320,
	"./easy-fit.svg": 6320,
	"./employees/profile": 9698,
	"./employees/profile.png": 9698,
	"./facebook-logo": 9947,
	"./facebook-logo.png": 9947,
	"./fit-pass": 4565,
	"./fit-pass.svg": 4565,
	"./ic-accessibility": 2507,
	"./ic-accessibility.svg": 2507,
	"./ic-air": 715,
	"./ic-air.svg": 715,
	"./ic-alert": 2673,
	"./ic-alert.svg": 2673,
	"./ic-apples": 94,
	"./ic-apples.svg": 94,
	"./ic-arrow-forward": 6888,
	"./ic-arrow-forward.svg": 6888,
	"./ic-bathroom-accessible": 978,
	"./ic-bathroom-accessible.svg": 978,
	"./ic-bike_rack": 9264,
	"./ic-bike_rack.svg": 9264,
	"./ic-brasil": 8069,
	"./ic-brasil.png": 8069,
	"./ic-calendar": 9431,
	"./ic-calendar.svg": 9431,
	"./ic-check": 6523,
	"./ic-check.svg": 6523,
	"./ic-checked": 4392,
	"./ic-checked.svg": 4392,
	"./ic-chile": 2651,
	"./ic-chile.png": 2651,
	"./ic-climbing_wall": 8295,
	"./ic-climbing_wall.svg": 8295,
	"./ic-clock": 4681,
	"./ic-clock.svg": 4681,
	"./ic-conditioner": 2173,
	"./ic-conditioner.svg": 2173,
	"./ic-convenience": 2814,
	"./ic-convenience.svg": 2814,
	"./ic-cybercafe": 1515,
	"./ic-cybercafe.svg": 1515,
	"./ic-document": 7782,
	"./ic-document.svg": 7782,
	"./ic-drinking_fountain": 1230,
	"./ic-drinking_fountain.svg": 1230,
	"./ic-dryer": 1797,
	"./ic-dryer.svg": 1797,
	"./ic-email": 519,
	"./ic-email.svg": 519,
	"./ic-express-coffee": 7883,
	"./ic-express-coffee.svg": 7883,
	"./ic-filter": 6499,
	"./ic-filter.svg": 6499,
	"./ic-fitness-center": 531,
	"./ic-fitness-center.svg": 531,
	"./ic-flavored-water": 2376,
	"./ic-flavored-water.svg": 2376,
	"./ic-global": 3475,
	"./ic-global.png": 3475,
	"./ic-gym": 486,
	"./ic-gym.svg": 486,
	"./ic-info": 1369,
	"./ic-info.svg": 1369,
	"./ic-iron_flatner": 9014,
	"./ic-iron_flatner.svg": 9014,
	"./ic-kids_space": 2117,
	"./ic-kids_space.svg": 2117,
	"./ic-kids_wc": 6399,
	"./ic-kids_wc.svg": 6399,
	"./ic-lock-outline": 8473,
	"./ic-lock-outline.svg": 8473,
	"./ic-locker_rooms": 3856,
	"./ic-locker_rooms.svg": 3856,
	"./ic-lockers": 5076,
	"./ic-lockers.svg": 5076,
	"./ic-logout": 4667,
	"./ic-logout.svg": 4667,
	"./ic-lounge": 6319,
	"./ic-lounge.svg": 6319,
	"./ic-mexico": 375,
	"./ic-mexico.png": 375,
	"./ic-navigate-next": 8614,
	"./ic-navigate-next.svg": 8614,
	"./ic-navigate-prev": 3242,
	"./ic-navigate-prev.svg": 3242,
	"./ic-nutritionist": 4417,
	"./ic-nutritionist.svg": 4417,
	"./ic-parking": 7559,
	"./ic-parking.svg": 7559,
	"./ic-perm-identity": 7634,
	"./ic-perm-identity.svg": 7634,
	"./ic-phone": 9399,
	"./ic-phone.svg": 9399,
	"./ic-physical_assessment": 2511,
	"./ic-physical_assessment.svg": 2511,
	"./ic-place": 8010,
	"./ic-place.svg": 8010,
	"./ic-plans": 9003,
	"./ic-plans.svg": 9003,
	"./ic-pool": 8319,
	"./ic-pool.svg": 8319,
	"./ic-shuttle": 7912,
	"./ic-shuttle.svg": 7912,
	"./ic-site": 9748,
	"./ic-site.svg": 9748,
	"./ic-snack_bar": 2779,
	"./ic-snack_bar.svg": 2779,
	"./ic-solarium": 9487,
	"./ic-solarium.svg": 9487,
	"./ic-steam_room": 2079,
	"./ic-steam_room.svg": 2079,
	"./ic-ticket": 7853,
	"./ic-ticket.svg": 7853,
	"./ic-timelapse": 6670,
	"./ic-timelapse.svg": 6670,
	"./ic-towels": 8453,
	"./ic-towels.svg": 8453,
	"./ic-transfer": 2068,
	"./ic-transfer.svg": 2068,
	"./ic-tv_treadmill": 7776,
	"./ic-tv_treadmill.svg": 7776,
	"./ic-valet_parking": 2664,
	"./ic-valet_parking.svg": 2664,
	"./ic-view": 3254,
	"./ic-view.svg": 3254,
	"./ic-wifi": 8718,
	"./ic-wifi.svg": 8718,
	"./icon_location": 6452,
	"./icon_location.png": 6452,
	"./img-banner": 1611,
	"./img-banner.jpg": 1611,
	"./instagram-logo": 9211,
	"./instagram-logo.png": 9211,
	"./key": 4989,
	"./key.svg": 4989,
	"./loading": 9272,
	"./loading.gif": 9272,
	"./logo": 4010,
	"./logo-acronym-green": 4044,
	"./logo-acronym-green.png": 4044,
	"./logo-mono": 7212,
	"./logo-mono.png": 7212,
	"./logo-nav-icon": 9222,
	"./logo-nav-icon.png": 9222,
	"./logo-responsive": 2196,
	"./logo-responsive.svg": 2196,
	"./logo-white": 9646,
	"./logo-white.png": 9646,
	"./logo-white.svg": 2806,
	"./logo.png": 4010,
	"./logo.svg": 5429,
	"./logo_img_wrapper_br": 7407,
	"./logo_img_wrapper_br.png": 7407,
	"./logo_img_wrapper_mx": 6740,
	"./logo_img_wrapper_mx.png": 6740,
	"./nelson-vargas": 4550,
	"./nelson-vargas.svg": 4550,
	"./no-image": 106,
	"./no-image.jpg": 106,
	"./novidade-booking": 8583,
	"./novidade-booking.png": 8583,
	"./nuevo-booking": 3064,
	"./nuevo-booking.png": 3064,
	"./onboarding_mx": 3946,
	"./onboarding_mx.png": 3946,
	"./onboarding_pt": 5765,
	"./onboarding_pt.png": 5765,
	"./patterns/3": 5768,
	"./patterns/3.png": 5768,
	"./patterns/4": 935,
	"./patterns/4.png": 935,
	"./patterns/header-profile": 4724,
	"./patterns/header-profile-skin-1": 950,
	"./patterns/header-profile-skin-1.png": 950,
	"./patterns/header-profile-skin-2": 1629,
	"./patterns/header-profile-skin-2.png": 1629,
	"./patterns/header-profile-skin-3": 5476,
	"./patterns/header-profile-skin-3.png": 5476,
	"./patterns/header-profile.png": 4724,
	"./patterns/otis_redding": 8950,
	"./patterns/otis_redding.png": 8950,
	"./patterns/shattered": 9747,
	"./patterns/shattered.png": 9747,
	"./placeholder-avatar": 8859,
	"./placeholder-avatar.svg": 8859,
	"./placeholder_avatar": 9298,
	"./placeholder_avatar.png": 9298,
	"./placeholder_photo": 4621,
	"./placeholder_photo.png": 4621,
	"./play-tennis": 3094,
	"./play-tennis.svg": 3094,
	"./smart-fit": 6041,
	"./smart-fit-mx": 1485,
	"./smart-fit-mx.svg": 1485,
	"./smart-fit.svg": 6041,
	"./sport-city": 734,
	"./sport-city.svg": 734,
	"./svg-wrapper-br": 373,
	"./svg-wrapper-br.svg": 373,
	"./svg-wrapper-mx": 3262,
	"./svg-wrapper-mx.svg": 3262,
	"./the-pilates": 3530,
	"./the-pilates.svg": 3530,
	"./velocity": 2822,
	"./velocity.png": 2822,
	"./vivo-47": 1728,
	"./vivo-47.svg": 1728,
	"./warning": 2443,
	"./warning.png": 2443,
	"./welcome_mailer/Icon_acesso": 761,
	"./welcome_mailer/Icon_acesso.png": 761,
	"./welcome_mailer/banner_email.es": 1314,
	"./welcome_mailer/banner_email.es.png": 1314,
	"./welcome_mailer/banner_email.pt-BR": 2645,
	"./welcome_mailer/banner_email.pt-BR.png": 2645,
	"./welcome_mailer/contato_icon": 8679,
	"./welcome_mailer/contato_icon.png": 8679,
	"./welcome_mailer/footer.es": 2876,
	"./welcome_mailer/footer.es.png": 2876,
	"./welcome_mailer/footer.pt-BR": 2535,
	"./welcome_mailer/footer.pt-BR.png": 2535,
	"./welcome_mailer/header": 7098,
	"./welcome_mailer/header.png": 7098,
	"./welcome_mailer/icone1_passo-a-passo": 1348,
	"./welcome_mailer/icone1_passo-a-passo.png": 1348,
	"./welcome_mailer/icone2_passo-a-passo": 123,
	"./welcome_mailer/icone2_passo-a-passo.png": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;